<template lang="html">
<div class="pgInner announcement">

    <div class="headBar">新建活动通知</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">标题</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params.title" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">来源</div>
                     <div class="bContent">
                           <el-form-item prop="source">
                                <el-input size="medium" class="inpText" v-model="params.source" placeholder="请输入发文机构，如多个机构，请用‘，’分割"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">图片</div>
                     <div class="bContent">
                           <img-upload :image="params.image" @imgChange="imgChange" tips="（115*70推荐）" />
                     </div>
                 </div>

                 <div class="enclosure">
                      <div class="ttl">附件</div>
                      <div class="ecContent">
                           <file-upload :files="params.fileId" @fileChange="fileChange" />
                      </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">正文</div>
                     <div class="bContent">
                         <textEditor ref="textEditor" :inContent="params.content" />
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

        <el-button @click="directSave(1)" type="primary" size="small">立即发布</el-button>
        <el-button @click="directSave(2)" plain size="small">存为草稿</el-button>
        <el-button @click="goReturn" plain size="small">取消</el-button>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { ancEdit, ancPredat } from "@/api/announcement/announcement";
import { dicSeek } from "@/api/pgMent/dictMent";
export default {
  components: {
    Editor
  },
  computed: {
    lineStr: function () {
      var str = '';
      if (this.navAct === 0 || this.navAct == 4) {
        str = 'width:60px;';
      } else {
        str = 'width:30px;';
      }

      str = str + "left:" + this.navX + "px;";

      return str;
    }
  },
  data() {
    return {

      pageH: '',
      editorText: '',
      pathurl: '',

      params: {
        id: '',
        title: '',
        source: '',
        content: '',
        status: '',
        type: '',
        image: '',
        fileId: '',
      },

      preCode: '',
      pgName: '',

      rules: {
        title: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
        source: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
      }

    }
  },

  methods: {

    fileChange: function (e) {    //  附件
      if (e.length > 0) {
        this.params.fileId = JSON.stringify(e);
      } else {
        this.params.fileId = '';
      }
    },

    pageFix: function () {
      this.pageH = document.documentElement.clientHeight - 205;
    },
    selectChange: function (eDat) {   //  数据字典
      this.params.status = eDat.id;
    },

    contentChange: function (e) {    // 富文本内容
      this.params.content = e;
    },

    goCreate: function (status) {  // 创建
      var vues = this;
      this.params.status = status;
      ancEdit({ notice: this.params }).then(res => {
        vues.$router.push('announcement');
      }).catch(err => { })
    },

    tmSave: function () {
      var vues = this;
      this.waitSave = setInterval(function () {
        var nowCode = JSON.stringify(vues.params);
        if (nowCode !== vues.preCode) {
          vues.goCreate(2);
          vues.preCode = nowCode;
        }
      }, 60000)
    },
    // 发布
    directSave: function (status) {
      var vues = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          vues.params.content = vues.$refs.textEditor.editorContent;
          if (!vues.params.content) {
            vues.$message.error('正文内容必须填写！');
          } else if (!vues.params.image) {
            vues.$message.error('请上传封面图!');
          } else {
            vues.goCreate(status);
          }
        }
      })
    },

    imgChange: function (e) {
      this.params.image = e;
    },

    goReturn: function () {
      this.$router.push('announcement');
    },

    prevSet: function () {

      var vues = this;
      var querys = this.$route.query;
      this.params.type = querys.typeid;

      // 底部定位
      this.pageFix();

      if (querys && querys.id) {
        this.params.id = querys.id;
        ancPredat({ id: querys.id }).then(res => {
          vues.params = res.notice;
        })
      } else {
        this.preCode = JSON.stringify(this.params);
        // this.tmSave();
      }

    },
  },
  created: function () {
    var vues = this;

    this.prevSet();
    $(window).resize(function () {
      vues.pageFix();
      vues.$refs.scroller.$data.sizeHeight = this.pageH;
    })

  },

  beforeDestroy: function () {
    clearInterval(this.waitSave);
  }


}
</script>

<style lang="scss" scoped>
.pgInner {
  background: #f5f5f5;
}

.headBar {
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody {
  margin: 20px;
}

.tabNavs {
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem {
    float: left;
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    margin-right: 45px;
    cursor: pointer;
  }
  .tabItem.act {
    color: rgb(86, 119, 252);
  }
  .moveLine {
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent {
  padding: 20px;
  background: white;
}

.pagefoot {
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn {
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1 {
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2 {
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }
}

.text-block {
  font-size: 14px;
  .bName {
    width: 60px;
    padding-top: 8px;
    float: left;
  }
  .bContent {
    margin-left: 60px;
    position: relative;
    margin-bottom: 20px;

    .inpText {
      width: 420px;
    }
  }
}

.enclosure {
  margin-top: 20px;
  margin-bottom: 45px;
  .ttl {
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
  }
  .ecContent {
    margin-left: 60px;
  }
}
</style>

<style lang="css">
.announcement .el-input__inner {
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// ancEdit.vue?4874a141